import { apiFetch } from "../utils"
import Cookies from "js-cookie"

const billingUrl = `himo-billing/`

export async function getAnnouncement(
  size: number,
  page: number,
) {
  const response = await apiFetch(`${billingUrl}announcements/?page=${page}&size=${size}`)

  if (!response.ok) {
    throw new Error("Cannot fetch announcements")
  }

  return response.json()
}


export async function getLatestAnnouncement() {
  const response = await apiFetch(`${billingUrl}announcements/recent/`)

  if (!response.ok) {
    throw new Error("Cannot fetch latest announcement")
  }

  return response.json()
}

export function validateAnnouncementPermission() {
  const restrictedGroups = [
    "HIMO Billing Staff",
    "HIMO Billing Consumer Support"
  ];

  const user = Cookies.get("user_info") || "{}";
  const parsedUser = JSON.parse(user);
  const userGroup = parsedUser.user_group;

  if (restrictedGroups.includes(userGroup)) {
    window.location.href = "/access-denied";
    return false;
  }

  return true;
}
